
function classof(char) {
    switch (char) {
        case ' ': return 'space';
        case '.': return 'period';
        case ',': return 'comma';
        case '!': return 'exclamation';
        case '\'': return 'apostraphe';
        case '-': return 'hyphen';
        case '?': return 'question-mark';
        case '#': return 'hashtag';
        case '=': return 'equals';
        case '+': return 'plus';

        case 'á':
        case 'é':
        case 'í':
        case 'ó':
        case 'ú':
        case 'ü':
        case 'ñ':
        case '¿':
        case '¡':
            return `es-${char}`;
        default:
            return char;
    }
}

export function capital(classes = 'br-md') {
    return `<div class="${classes} br-capital"></div>`;
}

function space(classes = 'br-md') {
    return `<div class="${classes} br-space"></div>`;
}

function stringToBraille(string, classes = 'br-md') {
    return string.split('')
        .map(c => {
            if (isAlpha(c) && c == c.toLocaleUpperCase())
                return `<div class="${classes} br-capital"></div>
<div class="${classes} br-${classof(c)}"></div>`;
            else return `<div class="${classes} br-${classof(c)}"></div>`
        }).join('\n');
}

function isAlpha(char) {
    return char.toLocaleLowerCase() != char.toLocaleUpperCase()
}

function wordHasAlphas(word) {
    return (word.split('').find(char => isAlpha(char)) !== undefined);
}


function brailleSayWord(string, classes = 'br-md') {

    var markup;

    //All Uppercase words 
    if (string == string.toLocaleUpperCase()) {
        if (wordHasAlphas(string)) {
            if (string.split('').length > 1)
                markup = `${capital(classes)}${capital(classes)}${stringToBraille(string.toLocaleLowerCase(), classes)}`;
            else
                markup = `${capital(classes)}${stringToBraille(string.toLocaleLowerCase(), classes)}`;
        }
        else {
            markup = `${stringToBraille(string.toLocaleLowerCase(), classes)}`;
        }
    }
    else {
        markup = stringToBraille(string, classes);
    }
    return markup;
}

export function brailleSay(string, classes = 'br-md') {
    if (string.includes(' ')) {
        var words = string.split(' ');
        return words.map(w => brailleSayWord(w, classes)).join(`\n${space(classes)}\n`);
    }
    else {
        return brailleSayWord(string, classes);
    }
}

export default {
    brailleSay,
};



// WEBPACK FOOTER //
// ./scripts/braillesay.js